import { render, staticRenderFns } from "./CustomerProjects.vue?vue&type=template&id=b5e20bd8&scoped=true"
import script from "./CustomerProjects.vue?vue&type=script&lang=ts"
export * from "./CustomerProjects.vue?vue&type=script&lang=ts"
import style0 from "./CustomerProjects.vue?vue&type=style&index=0&id=b5e20bd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e20bd8",
  null
  
)

export default component.exports